import { useGetUniversitiesLight } from '@actions';
import { useState } from 'react';
import useDebounce from './useDebounce';

const useUniversitySearch = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const debouncedSearch = useDebounce(searchQuery, 500);

  const { data: universities, isLoading } = useGetUniversitiesLight({
    search: debouncedSearch,
    limit: 20,
  });

  return {
    searchQuery,
    setSearchQuery,
    universities,
    isLoading,
  };
};

export default useUniversitySearch;
